import { create } from 'zustand'

export const useTooltipStore = create((set) => ({
  activeKey: null,
  onToggle: (key) =>
    set((s) => ({
      activeKey: s.activeKey === key ? null : key
    })),
  onClose: () => set({ activeKey: null })
}))